(() => {
  const MARKER = /^\[więcej\]$/i

  const slideDown = (el) => {
    if (!el) return
    el.classList.add('open')
    el.style.height = `${el.scrollHeight}px`
  }

  const slideUp = (el) => {
    if (!el) return
    el.style.height = '0px'
    el.classList.remove('open')
  }

  class ProductDescription extends HTMLElement {
    connectedCallback() {
      const marker = Array.from(this.children).find((child) =>
        MARKER.test((child.textContent || '').trim())
      )

      if (!marker) return

      const rest = []
      let sibling = marker.nextElementSibling
      while (sibling) {
        rest.push(sibling)
        sibling = sibling.nextElementSibling
      }

      if (!rest.length) {
        marker.remove()
        return
      }

      this.settings = {
        opened: false,
        moreText: this.dataset.openText || 'Zobacz więcej',
        lessText: this.dataset.closeText || 'Zwiń',
      }

      this.wrap = document.createElement('div')
      this.wrap.classList.add('main-product__description-more')
      this.wrap.style.height = '0px'
      this.wrap.setAttribute('aria-hidden', 'true')

      rest.forEach((node) => this.wrap.appendChild(node))
      marker.remove()

      this.toggler = document.createElement('button')
      this.toggler.type = 'button'
      this.toggler.classList.add('main-product__description-toggler', 'unstyled-button')
      this.toggler.setAttribute('aria-expanded', 'false')
      this.toggler.textContent = this.settings.moreText
      this.toggler.addEventListener('click', this.toggleContent)

      this.appendChild(this.wrap)
      this.appendChild(this.toggler)
    }

    toggleContent = () => {
      if (this.settings.opened) {
        this.wrap.classList.remove('main-product__description-more--opened')
        this.settings.opened = false
        this.toggler.textContent = this.settings.moreText
        this.toggler.setAttribute('aria-expanded', 'false')
        this.wrap.setAttribute('aria-hidden', 'true')
        slideUp(this.wrap)
      } else {
        this.wrap.classList.add('main-product__description-more--opened')
        this.settings.opened = true
        this.toggler.textContent = this.settings.lessText
        this.toggler.setAttribute('aria-expanded', 'true')
        this.wrap.setAttribute('aria-hidden', 'false')
        slideDown(this.wrap)
      }
    }
  }

  if (!customElements.get('product-description')) {
    customElements.define('product-description', ProductDescription)
  }
})()
